import { render, staticRenderFns } from "./StuffItem.vue?vue&type=template&id=2a4d3266&scoped=true"
import script from "./StuffItem.vue?vue&type=script&lang=js"
export * from "./StuffItem.vue?vue&type=script&lang=js"
import style0 from "./StuffItem.vue?vue&type=style&index=0&id=2a4d3266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d3266",
  null
  
)

export default component.exports